<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M8.48668 3.88331L2.4589 14.3233C1.78668 15.4878 2.62668 16.9444 3.97223 16.9444H16.0278C17.3733 16.9444 18.2133 15.4889 17.5411 14.3233L11.5133 3.88331C10.8411 2.71887 9.1589 2.71887 8.48668 3.88331Z"
            fill="var(--card-warning-background-light)"
        />
        <path
            d="M8.48668 3.88331L2.4589 14.3233C1.78668 15.4878 2.62668 16.9444 3.97223 16.9444H16.0278C17.3733 16.9444 18.2133 15.4889 17.5411 14.3233L11.5133 3.88331C10.8411 2.71887 9.1589 2.71887 8.48668 3.88331Z"
            stroke="var(--icons-warning-accent)"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10 7.22263V11.1115"
            stroke="var(--icons-warning-accent)"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10 15.0767C9.38667 15.0767 8.88889 14.5778 8.88889 13.9656C8.88889 13.3533 9.38667 12.8544 10 12.8544C10.6133 12.8544 11.1111 13.3533 11.1111 13.9656C11.1111 14.5778 10.6133 15.0767 10 15.0767Z"
            fill="var(--icons-warning-accent)"
        />
    </svg>
</template>
